import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAqz82pKpfK6DSAjrawJr9U7QasxU5MoPQ",
  authDomain: "mdsweets-16ae2.firebaseapp.com",
  projectId: "mdsweets-16ae2",
  storageBucket: "mdsweets-16ae2.firebasestorage.app",
  messagingSenderId: "248466172720",
  appId: "1:248466172720:web:cb24f7b6637062aabc76f5",
  measurementId: "G-3Z8BSJY5JZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);

// Set auth persistence to LOCAL (persists even when browser is closed)
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error("Error setting auth persistence:", error);
});

export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);

export default app;